import { ca } from '@cian/analytics';

export function trackAnswerClick() {
  ca('eventSite', {
    action: 'AddReviewReply',
    category: 'ReviewsJK',
    label: '',
    name: 'oldevent',
  });
}

export function trackAnswerSucceed(reviewId: string, answerId: string, subscribe: boolean) {
  if (subscribe) {
    ca('eventSite', {
      action: 'send',
      category: 'subscription',
      label: 'SendReviewsReplyJK',
      name: 'oldevent',
    });
  } else {
    ca('eventSite', {
      action: 'SendReviewReply',
      category: 'ReviewsJK',
      label: '',
      name: 'oldevent',
    });
  }
}

export const trackDislikeReview = () => {
  ca('eventSite', {
    action: 'DislikeReview',
    category: 'ReviewsJK',
    label: '',
    name: 'oldevent',
  });
};

export const trackHeaderReviewsLinkClick = () => {
  ca('eventSite', {
    action: 'click_head_reviews',
    category: 'Card_JK',
    label: '',
    name: 'oldevent',
  });
};

export const trackLikeReview = () => {
  ca('eventSite', {
    action: 'LikeReview',
    category: 'ReviewsJK',
    label: '',
    name: 'oldevent',
  });
};

export const trackReviewClick = () => {
  ca('eventSite', {
    action: 'AddReview',
    category: 'ReviewsJK',
    label: '',
    name: 'oldevent',
  });
};

// tslint:disable-next-line:variable-name
export const trackReviewSucceed = (_reviewId: string, subscribe: boolean) => {
  ca('eventSite', {
    action: 'SendReview',
    category: 'ReviewsJK',
    label: '',
    name: 'oldevent',
  });

  if (subscribe) {
    ca('eventSite', {
      action: 'send',
      category: 'subscription',
      label: 'SendReviewsJK',
      name: 'oldevent',
    });
  }
};

export const trackSubscribed = () => {
  ca('eventSite', {
    action: 'send',
    category: 'subscription',
    label: 'ReviewsJK',
    name: 'oldevent',
  });
};

export const trackSubscribePopupOpen = () => {
  ca('eventSite', {
    action: 'open',
    category: 'subscription',
    label: 'ReviewsJK',
    name: 'oldevent',
  });
};

export const trackUnsubscribed = () => {
  ca('eventSite', {
    action: 'send',
    category: 'unsubscription',
    label: 'ReviewsJK',
    name: 'oldevent',
  });
};

export const trackViewAllReviewsLinkClick = () => {
  ca('eventSite', {
    action: 'view_all_reviews',
    category: 'Card_JK',
    label: '',
    name: 'oldevent',
  });
};

export const trackViewFullReviewClick = () => {
  ca('eventSite', {
    action: 'ExpandReview',
    category: 'ReviewsJK',
    label: '',
    name: 'oldevent',
  });
};
